import { App } from 'vue'
import KJsonParse from './src/json-parse'
import deepcopy from "deepcopy";
import {menuLayout, basicLayout} from './src/tools/register'
export { disposeConfig } from "./src/tools/dispose";

KJsonParse.install = (app: App): void => {
  app.component(KJsonParse.name, KJsonParse)
}

// 获取布局对象
export const getBasicLayout = () => deepcopy(basicLayout)
// 注册布局对象
export const registerLayout = () => menuLayout

export default KJsonParse
